// D:\seat-reservation-react-v2\src\component\chatbot\Tabs.js
import React from "react";
import { FaPlusCircle } from "react-icons/fa";
import "./Tabs.scss";

const Tabs = ({
  activeTab,
  setActiveTab,
  onAddGroup,
  authUser,
  t = (key) => key,
}) => {
  const userRole = authUser?.role?.toLowerCase() || "super_admin";

  // Determine which roles to show based on current user's role
  const getAvailableRoles = () => {
    const roles = ["school", "vendor", "parent", "driver", "super_admin"];

    // Remove current user's own role
    const filteredRoles = roles.filter((role) => role !== userRole);

    // Super admin can see everyone
    if (userRole === "super_admin") return filteredRoles;

    // School can see: vendor, parent, driver, super_admin
    if (userRole === "school") {
      return ["vendor", "parent", "driver", "super_admin"];
    }

    // Vendor can see: school, parent, driver, super_admin
    if (userRole === "vendor") {
      return ["school", "parent", "driver", "super_admin"];
    }

    // Parent can see: school, vendor, driver, super_admin
    if (userRole === "parent") {
      return ["school", "vendor", "driver", "super_admin"];
    }

    // Driver can see: school, vendor, parent, super_admin
    if (userRole === "driver") {
      return ["school", "vendor", "parent", "super_admin"];
    }

    return filteredRoles;
  };

  const availableRoles = getAvailableRoles();

  // Role name translations
  const roleTranslations = {
    chats: t("chats"),
    groups: t("groups"),
    create_new_group: t("create_new_group"),
    school: t("school"),
    vendor: t("vendor"),
    parent: t("parent"),
    driver: t("driver"),
    super_admin: t("super_admin"),
  };

  const handleRoleTabClick = (role) => {
    setActiveTab(role);
  };

  // Check if current tab is a role tab
  const isRoleTab = availableRoles.includes(activeTab);
  return (
    <div className="tabs">
      <div className="top-row">
        <div
          className={`tab chats ${activeTab === "direct" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("direct");
          }}
        >
          {t("chats")}
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            className={`tab groups ${activeTab === "groups" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("groups");
            }}
            style={{ marginRight: 4 }}
          >
            {t("groups")}
          </div>
          <FaPlusCircle
            style={{ cursor: "pointer", fontSize: 18 }}
            onClick={() => onAddGroup && onAddGroup()}
            title={t("create_new_group")}
            data-testid="add-group-btn"
          />
        </div>
      </div>

      {/* Role Tabs - Always show for direct chat */}
      {(activeTab === "direct" || isRoleTab) && availableRoles.length > 0 && (
        <div className="role-tabs">
          {availableRoles.map((role) => {
            const localizedRole = roleTranslations[role] || role;

            return (
              <button
                key={role}
                className={`role-tab ${activeTab === role ? "active" : ""}`}
                onClick={() => handleRoleTabClick(role)}
                title={`${t("view")} ${localizedRole}`}
              >
                {localizedRole}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Tabs;
